import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { PartnerApiService } from '@vendasta/partner';
import { GetPartnerAccountGroupMappingResponseInterface } from '@vendasta/partner';

@Injectable({ providedIn: 'root' })
export class PartnerAccountGroupService {
  constructor(private api: PartnerApiService) {}

  getPartnerAccountGroupMapping(
    partnerId: string,
    accountGroupId: string,
  ): Observable<GetPartnerAccountGroupMappingResponseInterface> {
    const request = { partnerId: partnerId, accountGroupId: accountGroupId };
    return this.api.getPartnerAccountGroupMapping(request);
  }

  updatePartnerAccountGroup(partnerId: string, accountGroupId: string): Observable<boolean> {
    const request = { partnerId: partnerId, accountGroupId: accountGroupId };
    return this.api.updatePartnerAccountGroup(request).pipe(map(() => true));
  }

  swapPartnerAccountGroup(
    partnerId: string,
    accountGroupId: string,
    withPartnerId: string,
    withAccountGroupId: string,
  ): Observable<boolean> {
    const request = {
      partnerId: partnerId,
      accountGroupId: accountGroupId,
      withPartnerId: withPartnerId,
      withAccountGroupId: withAccountGroupId,
    };
    return this.api.swapPartnerAccountGroup(request).pipe(map(() => true));
  }
}
